var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { Entity, EntityBuilder, Type } from '@decahedron/entity';
import { Option } from 'packages/form/entities/question/Option';
import { FileAnswer } from 'packages/form/entities/FileAnswer';
import isNil from 'common/support/isNil';
var Question = /** @class */ (function (_super) {
    __extends(Question, _super);
    function Question() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.uuid = null;
        _this.type = 'text';
        _this.subtype = '';
        _this.label = '';
        _this.position = 0;
        _this.attribute = null;
        _this.validationRule = [];
        _this.multiselectLimit = null;
        return _this;
    }
    Object.defineProperty(Question.prototype, "isContactNonRemovableQuestion", {
        get: function () {
            return ['jobilla::name', 'jobilla::email', 'jobilla::phone'].includes(this.attribute);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Question.prototype, "isContactQuestion", {
        get: function () {
            var _a;
            return (_a = this.attribute) === null || _a === void 0 ? void 0 : _a.startsWith('jobilla::');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Question.prototype, "isContactConsentQuestion", {
        get: function () {
            return this.attribute === 'jobilla::contact_consent';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Question.prototype, "isYesNoQuestion", {
        get: function () {
            return this.subtype === 'polar';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Question.prototype, "isSelectOneQuestion", {
        get: function () {
            return this.type === 'select'
                && (isNil(this.subtype) || this.subtype === '')
                && this.attribute !== 'jobilla::contact_consent';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Question.prototype, "isFillableQuestion", {
        get: function () {
            return this.isYesNoQuestion || this.isSelectOneQuestion;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Question.prototype, "validationRulesForSubmission", {
        get: function () {
            if (this.type === 'file') {
                return this.validationRule.filter(function (rule) { return rule !== 'file'; });
            }
            if (this.subtype === 'website') {
                return __spreadArray(__spreadArray([], this.validationRule), ['url']);
            }
            return this.validationRule;
        },
        enumerable: false,
        configurable: true
    });
    Question.prototype.getUtilityColor = function (utilityPrefix) {
        if (this.type === 'select' && this.subtype === 'multiple') {
            return utilityPrefix + "-azure";
        }
        if (this.type === 'select' && this.subtype === 'polar') {
            return utilityPrefix + "-leaf";
        }
        if (this.type === 'select' && !this.subtype) {
            return utilityPrefix + "-sky-blue";
        }
        if (this.type === 'datetime') {
            return utilityPrefix + "-purple";
        }
        if (this.type === 'text' && this.subtype === 'email') {
            return utilityPrefix + "-midnight";
        }
        if (this.type === 'text' && this.subtype === 'website') {
            return utilityPrefix + "-fuchsia";
        }
        if (this.type === 'text') {
            return utilityPrefix + "-mandarine";
        }
        if (this.type === 'file') {
            return utilityPrefix + "-ultragreen";
        }
        if (this.type === 'opentext') {
            return utilityPrefix + "-gold";
        }
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Question.prototype.fromJson = function (jsonData) {
        _super.prototype.fromJson.call(this, jsonData);
        if (!jsonData.answer) {
            return this;
        }
        if (this.type === 'file') {
            this.answer = EntityBuilder.buildOne(FileAnswer, jsonData.answer);
        }
        else {
            this.answer = jsonData.answer;
        }
        return this;
    };
    Question.prototype.toJson = function (toSnake, asString) {
        var json = _super.prototype.toJson.call(this, toSnake, asString);
        if (json.multiselect_limit) {
            json.multiselect_limit = parseInt(this.multiselectLimit.toString());
        }
        return json;
    };
    Question.prototype.makeRule = function (rule, value) {
        var _a;
        if (value && !((_a = this.validationRule) === null || _a === void 0 ? void 0 : _a.includes(rule))) {
            this.validationRule.push(rule);
        }
        else if (!value) {
            this.validationRule = this.validationRule.filter(function (r) { return r !== rule; });
        }
    };
    __decorate([
        Type(Option),
        __metadata("design:type", Array)
    ], Question.prototype, "options", void 0);
    return Question;
}(Entity));
export { Question };
